module.exports = __webpack_public_path__ + "static/media/internet-group.ebf94a33.svg";